// extracted by mini-css-extract-plugin
var _1 = "c9jhT";
var _2 = "HRfwZ";
var _3 = "EMSgN";
var _4 = "T1Kf6";
var _5 = "x712j";
var _6 = "PkYzF";
var _7 = "yOjIy";
var _8 = "kk_QZ";
var _9 = "pe3au";
export { _1 as "copilotInboxHighPriorityIconColor", _2 as "copilotInboxLowPriorityIconColor", _3 as "copilotInboxNormalPriorityColor", _4 as "copilotInboxPriorityHighContrastColor", _5 as "copilotInboxPriorityIconForMLStyles", _6 as "copilotInboxPriorityIconForRPStyles", _7 as "copilotInboxPriorityIconForRPStylesCozyAndCompact", _8 as "copilotInboxPriorityIconForSettingsStyles", _9 as "iconContainer" }
